import { AudioManager } from "../../../AudioManager";
import { TurretActor } from "./TurretActor";
import { GameVars } from "../../../GameVars";
import * as Anuto from "../../../../engine/src";
import { GameConstants } from "../../../GameConstants";
import { BattleManager } from "../BattleManager";

export class CrossbowTurretActor extends TurretActor {

    constructor(scene: Phaser.Scene, position: {r: number, c: number}, turret: Anuto.Turret) {

        super(scene, Anuto.GameConstants.TURRET_PEA, position, turret, "texture_atlas_2", true);

        this.base.setFrame("torre_1_" + turret.level + "_01");
        this.base.setOrigin(.5, .75);
        
        this.cannon.setFrame("torre_1_bow_" + turret.level + "_01");
        this.cannon.y = -20;
        this.cannon.setOrigin(.5);
        
        if (GameConstants.SHOW_DEBUG_GEOMETRY) {
            
            const center = new Phaser.GameObjects.Graphics(this.scene);
            center.fillStyle(0xFFFF00);
            center.fillPoint(0, 0, 5);
            this.add(center);
        }
    }

    public upgrade(): void {

        super.upgrade();

        this.base.setFrame("torre_1_" + this.anutoTurret.level + "_01");
        this.cannon.setFrame("torre_1_bow_" + this.anutoTurret.level + "_01");
    }

    public shootArrow(): void {

        if (GameVars.currentMapZone === 0 && !GameVars.gameData.specialAttacks[0]) {
            if (GameVars.currentMapCount === 1) {

                this.scene.time.addEvent({ delay: 1000, callback: () => {

                    BattleManager.showSpecialAttack(0);
                   
                }, callbackScope: this});
            }
        }

        this.cannon.anims.play("torre_1_bow_" + this.anutoTurret.level);

        this.cannon.on("animationcomplete", () => {
            this.cannon.setFrame("torre_1_bow_" + this.anutoTurret.level + "_01");
        }, this);

        this.cannon.rotation = - this.rotation + this.anutoTurret.shootAngle + Math.PI / 2;

        this.scene.tweens.add({
            targets: this.cannon,
            x: - 5 * Math.sin(this.cannon.rotation),
            y: 5 * Math.cos(this.cannon.rotation) - 20,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: GameVars.timeStepFactor === 1 ? 40 : 10,
            onComplete: () => {
                
                if (!this.scene) {
                    return;
                }
                
                this.scene.tweens.add({
                    targets: this.cannon,
                    x: 0,
                    y: - 20,
                    ease: Phaser.Math.Easing.Cubic.Out,
                    duration: GameVars.timeStepFactor === 1 ? 40 : 10
                });
            },
            onCompleteScope: this
        });

        AudioManager.playSound("ballista", false, .55 + .15 * this.anutoTurret.level, 1 - .2 * this.anutoTurret.level);
    }
}
